import React from "react";

const Register = () => {
  return (
    <div>
      <h1>welcome to register user page</h1>
    </div>
  );
};

export default Register;
